<header class="flex header">
  <h2>
    @if (locationToEdit?.id) {
      {{ 'Locations_Edit' | translateWF: 'Edit Location' }}
    } @else if (parentLocation) {
      {{ 'Locations_Add_Child' | translateWF: 'Add Child Location' }}
    } @else {
      {{ 'Locations_Add_Site' | translateWF: 'Add Site' }}
    }
  </h2>
  <p-button icon="pi pi-times" (onClick)="onClose()" [disabled]="isLoading" />
</header>

@if (isLoading) {
  <p-progressBar mode="indeterminate" [style]="{ height: '6px' }" />
}

<section class="content">
  <p-card>
    <!-- Parent Location Info (if adding child) -->
    @if (parentLocation) {
      <div class="bg-blue-50 p-4 rounded mb-4 border border-blue-200">
        <p class="text-sm text-gray-600 mb-1">
          {{
            'Locations_Creating_Child_For'
              | translateWF
                : 'Creating child location
        for:'
          }}
        </p>
        <p class="font-semibold text-lg">
          {{ localHelperTranslate.getLocalizedValue(parentLocation.name) }}
          <span class="text-gray-500 text-sm">({{ parentLocation.locationCode }})</span>
        </p>
        <p class="text-sm text-blue-600 mt-2">
          {{ 'Locations_New_Type' | translateWF: 'New location type:' }}
          <strong>{{ childTypeName }}</strong>
        </p>
      </div>
    }

    <!-- Translation Toggle -->
    <div class="row-start-center gap-3 mb-4">
      <i class="pi pi-language"></i>
      <p>{{ 'LocationModal.Switch' | translateWF: 'Spanish Translate' }}</p>
      <p-toggleSwitch [(ngModel)]="showTranslateInputs" />
    </div>

    <form [formGroup]="locationFormGroup">
      <div class="col">
        <!-- CODE FIELD -->
        <div class="form-box">
          <label>{{ 'Locations_Code' | translateWF: 'Location Code' }} *</label>
          @if (isEditing) {
            <small class="text-gray-600 block mb-1">
              {{ 'Locations_Code_Immutable' | translateWF: 'Location code cannot be changed after creation.' }}
            </small>
            <p>{{ fullLocationCodePreview }}</p>
          } @else {
            <input
              pInputText
              type="text"
              class="w-full"
              formControlName="code"
              placeholder="e.g., WH-RM-1"
              [ngClass]="{
                'ng-invalid ng-dirty': submittedForm && locationFormGroup.get('code')?.invalid,
              }"
            />
          }

          @if (fullLocationCodePreview) {
            <small class="text-gray-600 mt-1 block">
              {{ 'Locations_Full_Code' | translateWF: 'Full code:' }}
              <code class="bg-gray-100 px-2 py-1 rounded">{{ fullLocationCodePreview }}</code>
            </small>
          }
          @if (submittedForm && locationFormGroup.get('code')?.invalid) {
            <div class="text-red-500 text-sm mt-1">
              {{ 'Common_Code_Required' | translateWF: 'Code is required.' }}
            </div>
          }
        </div>

        <!-- NAME FIELD (Translatable) -->
        <div class="form-box" [formGroup]="locationNameFormGroup">
          <label>{{ 'Common_Name' | translateWF: 'Name' }} *</label>

          <p-inputGroup>
            <p-inputGroupAddon>EN</p-inputGroupAddon>
            <input
              pInputText
              type="text"
              class="w-full"
              formControlName="en"
              placeholder="Location name in English"
              [ngClass]="{
                'ng-invalid ng-dirty': submittedForm && locationNameFormGroup.get('en')?.invalid,
              }"
            />
          </p-inputGroup>

          @if (showTranslateInputs) {
            <p-inputGroup class="mt-2">
              <p-inputGroupAddon>ES</p-inputGroupAddon>
              <input pInputText type="text" class="w-full" formControlName="es" placeholder="Nombre de ubicación en español" />
            </p-inputGroup>
          }

          @if (submittedForm && locationNameFormGroup.get('en')?.invalid) {
            <div class="text-red-500 text-sm mt-1">
              {{ 'Common_Name_Required' | translateWF: 'Name is required.' }}
            </div>
          }
        </div>

        <!-- DESCRIPTION FIELD (Translatable) -->
        <div class="form-box" [formGroup]="locationDescriptionFormGroup">
          <label>{{ 'Common_Description' | translateWF: 'Description' }}</label>
          <p-inputGroup>
            <p-inputGroupAddon>EN</p-inputGroupAddon>
            <textarea rows="2" pTextarea class="w-full" formControlName="en" placeholder="Optional description"></textarea>
          </p-inputGroup>

          @if (showTranslateInputs) {
            <p-inputGroup class="mt-2">
              <p-inputGroupAddon>ES</p-inputGroupAddon>
              <textarea rows="2" pTextarea class="w-full" formControlName="es" placeholder="Descripción opcional"></textarea>
            </p-inputGroup>
          }
        </div>

        <!-- IS STORABLE CHECKBOX -->
        <div class="row-start-center">
          <p-checkbox formControlName="isStorable" [binary]="true" inputId="isStorable" />
          <label for="isStorable" class="cursor-pointer">
            {{ 'Locations_Is_Storable' | translateWF: 'Can store inventory items' }}
          </label>
        </div>
      </div>
    </form>
  </p-card>
</section>

<footer>
  <p-button class="w-full" [label]="'Common_Save' | translateWF: 'Save'" (onClick)="onSave()" [disabled]="isLoading" />
  <p-button class="w-full" [label]="'Common_Exit' | translateWF: 'Exit'" severity="secondary" variant="outlined" (onClick)="onClose()" [disabled]="isLoading" />
</footer>
